import React from "react";
import { useTranslation } from "react-i18next";

export default function AttachmentList({
 message,onDownloadFile,isMine = false

}) {

    
        const { t } = useTranslation();
    //-------------------------------------------------------
    // Sécurisation
    //-------------------------------------------------------

    if (!message) return null;

    //-------------------------------------------------------
    // Liste des pièces jointes
    //-------------------------------------------------------

    const attachments = [

        message.attachedFile1,
        message.attachedFile2,
        message.attachedFile3,
        message.attachedFile4

    ].filter(Boolean);

    //-------------------------------------------------------

    if (attachments.length === 0) {

        return null;

    }

    //-------------------------------------------------------

    const getIcon = (fileName) => {

        const extension = fileName
            .split(".")
            .pop()
            .toLowerCase();

        switch (extension) {

            case "pdf":
                return "bi-file-earmark-pdf-fill text-danger";

            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
            case "bmp":
            case "webp":
                return "bi-file-earmark-image-fill text-success";

            default:
                return "bi-paperclip";

        }

    };

    //-------------------------------------------------------

    return (

        <div className="message-attachments">

            <div
                className={
                    isMine
                        ? "message-attachments-title text-white"
                        : "message-attachments-title text-success"
                }
            >

                <i className="bi bi-paperclip"></i>
               {t("common.attachments")}
            </div>

            {
                attachments.map((fileName, index) => (

                    <div

                        key={index}

                        className="message-file"

                        onClick={() =>
                            onDownloadFile(
                                message.id,
                                index + 1
                            )
                        }

                    >

                        <div className="d-flex align-items-center">

                            <i
                                className={`${getIcon(fileName)} fs-4 me-3`}
                            ></i>

                            <span className="message-file-name">

                                {fileName}

                            </span>

                        </div>

                        <button

                            type="button"

                            className="download-file-btn"

                        >

                            <i className="bi bi-download"></i>

                        </button>

                    </div>

                ))

            }

        </div>

    );

}